import { DevicesProvider } from './../../providers/devices/devices';
import { TasksProvider } from './../../providers/tasks/tasks';
import { Component } from '@angular/core';
import {
  NavController,
  NavParams,
  AlertController
} from 'ionic-angular';
import { TaskData } from '../../providers/tasks/models';
import { TasksPage } from '../tasks/tasks';
import { getValue } from '../../providers/tasks/filters';

@Component({
  selector: 'page-task-test',
  templateUrl: 'task-test.html'
})
export class TaskTestPage {

  showSupportButtons: boolean = false;
  public task: any;
  public test: boolean = true;
  private taskData: TaskData;
  private testDefault: any = `
    {
    "steps":[
    {
    "id":"000-initialize",
    "state":"NOT_STARTED",
    "title":"Initialize test"
    },
    {
    "id":"010-geyser-connected",
    "state":"NOT_STARTED",
    "title":"Connection"
    },
    {
    "id":"020-geyser-responds",
    "state":"NOT_STARTED",
    "title":"Responsivity"
    },
    {
    "id":"030-no-faults",
    "state":"NOT_STARTED",
    "title":"Faults"
    },
    {
    "id":"040-battery-diagnostics",
    "state":"NOT_STARTED",
    "title":"Battery diagnostics"
    },
    {
    "id":"050-valve-diagnostics",
    "state":"NOT_STARTED",
    "title":"Valve diagnostics"
    },
    {
    "id":"060-drip-tray-diagnostics",
    "state":"NOT_STARTED",
    "title":"Drip tray diagnostics"
    }
    ],
    "state":"NOT_STARTED"
    }`;
  public test_data: any;
  private serial: string;
  private testint: any;
  private testSubscription: any;
  private extras: any;
  private isrepair: boolean;
  isreplace: boolean;
  faults: any[];
  public lowRssi: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private alertCtrl: AlertController
  ) {
    this.task = this.tasksProvider.getSelectedTask();
    this.faults = this.devicesProvider.faults;
  }

  ionViewDidLoad() {
    this.task = this.tasksProvider.getSelectedTask(); // this.navParams.get('task');
    this.taskData = this.tasksProvider.getTaskData(this.task.id);

    this.test_data = JSON.parse(this.testDefault);
    this.extras = this.navParams.get('extras');
    this.isrepair = this.extras.isrepair;

    this.isreplace =
      this.extras && this.extras.isreplace ? this.extras.isreplace : null;

    this.serial = this.isrepair
      ? this.devicesProvider.getSerial(this.taskData.verified)
      : this.devicesProvider.getSerial(this.taskData.code);

    if(this.taskData.deviceReplace && this.taskData.code){
      this.serial = this.taskData.code;
    }
  }
  ionViewDidEnter() {
    this.showSupportButtons = false;
    this.taskData = this.tasksProvider.getTaskData(this.task.id);
    if (this.taskData.test) this.test = this.taskData.test;
  }
  ionViewDidLeave() {
    if (this.testint) clearInterval(this.testint);
    if (this.testSubscription) this.testSubscription.unsubscribe();
  }

  initTest() {
    this.showSupportButtons = false;
    // TODO: EXTRA CHECK HERE
    this.test = false;
    this.devicesProvider.getDeviceInfo(this.serial).subscribe(
      result => {
        const connected = getValue(result,'state.reported.connected') ? true: false;
        if (!connected) {
          this.showSupportButtons = true;
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message:
              'The device is not connected. Please wait for the device to connect (indicated by two solid green lights) and try again.<br><br>If the device has not connected within a minute, try resetting the device again.',
            buttons: [
              {
                text: 'OK',
                role: 'ok',
                handler: data => {
                  this.afterError();
                  // for debugging this.updateTask();
                }
              }
            ]
          });
          alert.present();
        } else {
          const strength = getValue(result,'state.reported.signalRssi');
          const signalRssi = strength ? strength: 0;

          if(signalRssi < 5){
            this.lowRssi = true;
          } else {
            this.startTest();
          }
        }
      },
      e => {
        // test anyway
        this.startTest();
      }
    );
  }

  startTest() {
    this.test = false;
    let sn = this.serial;

    this.devicesProvider.startTest(sn, this.task).subscribe(
      test_result => {
        this.test_data = test_result;
        this.testCheck();
      },
      e => {
        this.displayNonDeviceError(e);
        clearInterval(this.testint);
        this.test = false;
      }
    );
  }

  testCheck() {
    let sn = this.serial; // == '3894293GEYSER' ? '3894299GEYSER' : this.serial;
    this.testSubscription = this.devicesProvider.getTest(sn).subscribe(
      testResult => {
        // console.log(testResult);
        this.test_data = testResult;
        if (this.test_data.state && this.test_data.state == 'SUCCEEDED') {
          this.updateTask();
          clearInterval(this.testint);
          this.test = false;
        } else if (this.test_data.state && this.test_data.state == 'FAILED') {
          this.showSupportButtons = true;
          let err = '';
          const errors = this.test_data.steps.filter(step => {
            return step.state === 'FAILED' ? true : null;
          });

          const error_arr = errors.map(error => {
            return error.errors;
          });

          const error_messages = error_arr.map(err => {
            return err.toString();
          });

          err =
            error_messages && error_messages.length > 0
              ? err +
                '<p class="error-label "><strong>Errors:</strong><br>' +
                error_messages.join('<br>') +
                '</p>'
              : err;

          console.log(errors, error_arr, error_messages);

          clearInterval(this.testint);
          this.test = false;
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message:
              'There was an error testing the device. Reset the device and test again to retry.' +
              err,
            buttons: [
              {
                text: 'OK',
                role: 'ok',
                handler: data => {
                  this.afterError();
                }
              }
            ]
          });
          alert.present();
        } else if (!this.test_data.state) {
          this.showSupportButtons = true;
          clearInterval(this.testint);
          this.test = false;
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: 'The device did not return a state',
            buttons: [
              {
                text: 'OK',
                role: 'ok',
                handler: data => {
                  this.afterError();
                }
              }
            ]
          });
          alert.present();
          clearInterval(this.testint);
          this.test = false;
        } else {
          setTimeout(() => {
            this.testCheck();
          }, 1000);
        }
      },
      e => {
        // this.test_data.steps.forEach(element => {
        //   if (element.state === 'NOT_STARTED') {
        //     element.state = 'FAILED';
        //   }
        // });
        this.displayNonDeviceError(e);
        clearInterval(this.testint);
        this.test = false;
      }
    );
  }

  displayNonDeviceError(err) {
    console.log('ERROR: ', err);
    this.showSupportButtons = true;
    const message =
      err && err.status === 0
        ? 'There was an error communicating with the server. Check your internet connection and try again.'
        : err && err.error && err.error.message
        ? err.error.message
        : 'An unknown error occured. ';
    let alert = this.alertCtrl.create({
      title: 'Error',
      message: message,
      buttons: [
        {
          text: 'OK',
          role: 'ok',
          handler: data => {
            this.afterError();
          }
        }
      ]
    });
    alert.present();
  }

  afterError() {
    this.test = true;
    if (this.isrepair) {
      this.tasksProvider
        .updateTaskData(this.task, 'testrepair', 'error')
        .subscribe(data => {
          // done
        });
    }
  }

  friendlyState(state) {
    let txt = state
      .toLowerCase()
      .split('_')
      .join(' ');
    return txt;
  }

  doTest(id = 0, status = 0) {
    this.test = false;
    setTimeout(test => {
      this.setTest(id, status);
      let next_status = status + 1;
      let next_id = id;
      if (next_status >= 3) {
        next_status = 0;
        next_id++;
      }
      if (next_id < 5) {
        this.doTest(next_id, next_status);
      } else {
        this.updateTask();
      }
    }, 400);
  }
  setTest(id, status) {
    this.test_data[id].status = status;
  }

  updateTask() {
    let type = !this.isrepair ? 'test' : 'testrepair';
    if(this.taskData.deviceReplace &&
      this.taskData.code &&
      this.taskData.testrepair){
      type = 'test'
    }

    this.tasksProvider
      .updateTaskData(this.task, type, this.test_data)
      .subscribe(data => {
        this.navCtrl.pop();
      });
  }
  replaceController(){
    this.navCtrl.push(TasksPage, {
      task: this.task,
      fromTest: {replace: true}
    });
  }

  addNewAerial(add: boolean){
    if(add){
      this.navCtrl.pop();
    } else {
      this.lowRssi = false;
      this.startTest();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-test/task-test.ts